import { activateKlaviyoEmbed } from './klaviyo-embed.js';

class KlaviyoNewsletter extends HTMLElement {
  #cleanup;
  #observer;
  #timeout;
  #frame;

  connectedCallback() {
    if (this.#cleanup) return;
    this.#cleanup = activateKlaviyoEmbed(this, this.#start);
  }

  disconnectedCallback() {
    this.#cleanup?.();
    this.#cleanup = undefined;
    this.#observer?.disconnect();
    clearTimeout(this.#timeout);
    cancelAnimationFrame(this.#frame);
    this.#frame = undefined;
  }

  #start = () => {
    const embed = this.querySelector('[data-klaviyo-newsletter-embed]');
    if (!embed) return;
    this.setAttribute('aria-busy', 'true');
    this.#observer = new MutationObserver(this.#scheduleUpdate);
    this.#observer.observe(embed, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'hidden', 'style'],
    });
    // An offscreen form must not time out before it is requested.
    this.#timeout = setTimeout(this.#showError, 8000);
    this.#scheduleUpdate();
  };

  #scheduleUpdate = () => {
    if (this.#frame !== undefined) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = undefined;
      const embed = this.querySelector('[data-klaviyo-newsletter-embed]');
      const form = embed?.querySelector('form[data-testid^="klaviyo-form-"]');
      const email = embed?.querySelector('input[type="email"]');
      const rendered = Boolean(form || email);
      const success = Boolean(form && !(email && email.getClientRects().length));
      if (embed && embed.classList.contains('klaviyo-newsletter-embed--success') !== success) {
        embed.classList.toggle('klaviyo-newsletter-embed--success', success);
      }
      if (rendered) {
        clearTimeout(this.#timeout);
        if (!this.hasAttribute('data-klaviyo-ready')) {
          this.toggleAttribute('data-klaviyo-transition', !this.querySelector('[data-klaviyo-loading]')?.hidden);
          this.setAttribute('data-klaviyo-ready', '');
        }
        this.querySelector('[data-klaviyo-loading]')?.toggleAttribute('hidden', true);
        this.setAttribute('aria-busy', 'false');
        const fallback = this.querySelector('[data-klaviyo-newsletter-fallback]');
        if (fallback) fallback.hidden = true;
      }
    });
  };

  #showError = () => {
    if (!this.querySelector('[data-klaviyo-newsletter-embed] form, [data-klaviyo-newsletter-embed] input[type="email"]')) {
      this.querySelector('[data-klaviyo-loading]')?.toggleAttribute('hidden', true);
      this.setAttribute('aria-busy', 'false');
      const fallback = this.querySelector('[data-klaviyo-newsletter-fallback]');
      if (fallback) fallback.hidden = false;
    }
  };
}

if (!customElements.get('klaviyo-newsletter')) {
  customElements.define('klaviyo-newsletter', KlaviyoNewsletter);
}
